module.exports = __webpack_public_path__ + "static/media/aflac-choice-text.e525b092.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/aflac-choice-text.png
// module id = 7825
// module chunks = 13